import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Form, Input, Space } from 'antd';
import StoreSettingService from "services/store_setting";
import ImagePicker from "components/pickers/image/ImagePicker"
import ThemeSetting from "components/pickers/theme-setting"
import { useForm, useWatch } from "antd/es/form/Form";
import { useApp } from 'contexts/app';
const service = new StoreSettingService();

const WebsiteSetting = () => {
    const [form] = useForm();
    const { showLoading, showNotify, message } = useApp();
    const [oldSetting, setOldSetting] = useState({})
    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        var setting = await service.getWebsiteSetting();
        form.setFieldsValue(setting);
        setOldSetting(setting);
    }

    const onFinish = async values => {
        // console.log('Success:', values);
        showLoading(true);
        try {
            await service.saveWebSiteSetting(values)
            await loadData();
            showNotify("Đã cập nhật")
        } catch (error) {
            message.error("Không thể nhật")
        }
        showLoading(false);

    };
    const onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };
    return (


        <Form
            form={form}
            name="basic"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ maxWidth: 600 }}
            initialValues={{ remember: true }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
        >
            <Form.Item
                label="Link"
                name="url"
                rules={[{
                    required: true,

                },
                {

                    pattern: /^[0-9a-z]{5,30}$/,
                    message: 'Url từ 5 đến 30 ký tự chỉ số và chữ'
                },
                {
                    validator: async (_, value) => {

                        return new Promise(async (r, e) => {

                            try {
                                var data = await service.checkSiteUrl(value);
                                if (data.error) {
                                    e(new Error(data.error));
                                    return;
                                }
                                r();

                            } catch (error) {

                                e(new Error('Không thể kiểm tra'));
                            }

                        })




                    },
                }
                ]}
            >
                <Input suffix={<> <Space>.sipro.store <Button type='link' onClick={e => window.open(`https://${oldSetting.url}.sipro.store`)}>Xem</Button> <Button onClick={e => window.navigator.clipboard.writeText(`https://${oldSetting.url}.sipro.store`)}>Copy</Button> </Space>  </>} />
            </Form.Item>

            <Form.Item
                label="Tiêu đề"
                name="title"
                rules={[{ required: true, message: 'Please input your website!' }]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                label="Hình ảnh"
                name="image"
                rules={[]}
            >
                <ImagePicker ></ImagePicker>
            </Form.Item>


            <Form.Item
                label="Mô tả"
                name="description"
                rules={[]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                label="Màu sắc"
                name="theme"
                rules={[]}
            >
                <ThemeSetting />
            </Form.Item>




            <Form.Item
                label="Link chat"
                name="chat_url"
                tooltip={<>
                    Có thể dùng Zalo hoặc Facebook
                    <div>Zalo : https://zalo.me/số_điện_thoại</div>
                    <div>Facebook : http://m.me/PAGE-NAME</div>
                </>}
                rules={[]}
            >
                <Input />
            </Form.Item>


            <Form.Item
                label="Địa chỉ "
                name="address"
                rules={[]}
            >
                <Input />
            </Form.Item>
            <Form.Item label={null}>
                <Button type="primary" htmlType="submit">
                    Cập nhật
                </Button>
            </Form.Item>
        </Form>
    )
}
export default WebsiteSetting;